import React from 'react';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BoldSmallBodyText, Header5Text, SmallBodyText, SpacerRow, Tooltip } from 'ui-toolkit';

export interface IExpectedBuyerMoneyLabelProps {}

export const ExpectedBuyerMoneyLabel: React.FC<IExpectedBuyerMoneyLabelProps> = () => {
  return (
    <Tooltip
      placement={'bottom'}
      tooltipContent={
        <>
          <BoldSmallBodyText>What is this?</BoldSmallBodyText>
          <SmallBodyText>
            This represents value of the funds that Spruce expects to fulfill Buyer Cash to Close.
          </SmallBodyText>
          <SpacerRow />
          <BoldSmallBodyText>How is it calculated?</BoldSmallBodyText>
          <SmallBodyText>
            Purchase price
            <br />
            + Buyer closing costs to be paid at closing
            <br />
            + Adjustments paid by buyer
            <br />
            - Adjustments paid on behalf of buyer
            <br />
            - Loan amount
            <br />= Expected Buyer Money
          </SmallBodyText>
        </>
      }
    >
      <div className={'flex flex-row gap-1 items-center'}>
        <Header5Text>Buyer</Header5Text>
        <FontAwesomeIcon icon={faQuestionCircle} />
      </div>
    </Tooltip>
  );
};
